import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Card, Modal } from "react-bootstrap";
import { toDateTimeFR } from "../../../utils/datesHeures";

const BlocActualitesThumbnail = (props) => {
  const { t } = useTranslation();
  const { actualiteObject } = props;
  const [showDetailActu, setShowDetailActu] = useState(false);

  const openModal = () => {
    setShowDetailActu(true);
  };

  const closeModal = () => {
    setShowDetailActu(false);
  };
  return (
    <>
      <Card className="d-flex flex-column justify-content-between align-items-center componentActualiteThumbnail m-2">
        <span className="overflowInContent" onClick={openModal}>
          {/* onClick={setShowDetailActu(true)} */}
          <div className="text-center">
            <Card.Img
              className="vignetteActualite p-1 m-auto"
              variant="top"
              src={actualiteObject.vignette}
            />
          </div>
          <Card.Body>
            <div className="date">
              {t("public.componentActualite.publieLe")}{" "}
              {toDateTimeFR(actualiteObject.date_publication)}
            </div>
            <Card.Title className="mt-2">{actualiteObject.titre}</Card.Title>
            <div className="titreEspace">{actualiteObject.nom}</div>
          </Card.Body>
        </span>
        <Button
          href={
            process.env.REACT_APP_URL_COLIDEE +
            "/o" +
            actualiteObject.id_entreprise +
            "p" +
            actualiteObject.id_plateforme +
            "/detailactualite-" +
            actualiteObject.id_actualite +
            ".htm"
          }
          target="_blank"
          rel="noreferrer"
          className="buttonCard"
        >
          {t("public.boutons.je_m_interesse")}
        </Button>
      </Card>

      <Modal size="lg" show={showDetailActu} onHide={closeModal} className="modalDetailActu">
        <Modal.Header closeButton>
          <Modal.Title>
            {actualiteObject.titre}
            <div className="sousTitreDetail">
              {t("public.componentActualite.publieLe")}{" "}
              {toDateTimeFR(actualiteObject.date_publication)}{" "}
              {t("public.componentActualite.publiePar")}{" "}
              <a
                href={process.env.REACT_APP_URL_COLIDEE + "/o" + actualiteObject.id_entreprise}
                target="_blank"
                rel="noreferrer"
              >
                {actualiteObject.nom_entreprise}
              </a>{" "}
              {t("public.componentActualite.publieSur")}{" "}
              <a
                href={
                  process.env.REACT_APP_URL_COLIDEE +
                  "/o" +
                  actualiteObject.id_entreprise +
                  "p" +
                  actualiteObject.id_plateforme
                }
                target="_blank"
                rel="noreferrer"
              >
                {actualiteObject.nom}
              </a>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div dangerouslySetInnerHTML={{ __html: actualiteObject.contenu }} />
          <hr />
          <a
            href={
              process.env.REACT_APP_URL_COLIDEE +
              "/o" +
              actualiteObject.id_entreprise +
              "p" +
              actualiteObject.id_plateforme +
              "/detailactualite-" +
              actualiteObject.id_actualite +
              ".htm"
            }
            target="_blank"
            rel="noreferrer"
          >
            <Button className="buttonCard float-end  w-25">
              {t("public.componentActualite.consulter")}
            </Button>
          </a>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default BlocActualitesThumbnail;
